import appApiService from '@/shared/services/app-api.service'
import { TOAST_DISPATCHERS } from '@/shared/constants/store-constants/toast'
import i18n from '@/app/i18n'

export default {
  resetStore({ commit }) {
    commit('RESET_STORE')
  },

  parsePayload({ commit }, payload) {
    commit('SET_COINS', payload)
  },

  copyToClipboard({ dispatch }, text) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        dispatch(
          TOAST_DISPATCHERS.setSuccessMessage,
          {
            title: i18n.global.t('PaymentLinks | toast | copied | title'),
            message: '',
          },
          { root: true }
        )
      })
      .catch((err) => {
        if (!err.isHandled) {
          dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
        }
      })
  },

  copyFileToClipboard({ dispatch }, fileBlob, fileType = 'image/png') {
    const file = new ClipboardItem({ [fileType]: fileBlob })

    navigator.clipboard
      .write([file])
      .then(() => {
        dispatch(
          TOAST_DISPATCHERS.setSuccessMessage,
          { title: 'Information message', message: 'File successfully copied' },
          { root: true }
        )
      })
      .catch((err) => {
        console.error('Error copying file:', err)
        if (!err.isHandled) {
          dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
        }
      })
  },

  async getCoins({ commit, dispatch }) {
    try {
      commit('SET_LOADING', true)

      const response = await appApiService.getCoins()

      dispatch('parsePayload', response.coins)

      return response.coins
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },
}
